import {
  Button,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  PageTabs,
  PageTabsList,
  PageTabsTrigger,
} from "@tellescope/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PortalSchemaTabContent } from "./PortalSchemaTabContent";
import { RoleAdminTabContent } from "./RoleAdminTabContent";
import { RoleSettingsTabContent } from "./RoleSettingsTabContent";
import { UIRestrictionsTabContent } from "./UIRestrictionsTabContent";
import { useEditRoleDialog } from "./useEditRoleDialog";

export interface EditRoleDialogContentsProps {
  roleId?: string;
  onClose: () => void;
}

export const EditRoleDialogContents = ({ roleId, onClose }: EditRoleDialogContentsProps) => {
  const { t } = useTranslation("settings");
  const [selectedSection, setSelectedSection] = useState("settings");

  const editor = useEditRoleDialog(roleId);

  return (
    <DialogContent divided style={{ maxWidth: "min(90vw, 900px)" }} className="w-[900px]">
      <PageTabs value={selectedSection} onValueChange={setSelectedSection} className="min-w-0">
        <DialogHeader className="p-0 space-y-2">
          <DialogTitle className="px-6 pt-4">{editor.role?.role ?? t("Edit Role")}</DialogTitle>
          <PageTabsList className="h-10 px-6">
            <PageTabsTrigger value="settings">{t("Role settings")}</PageTabsTrigger>
            <PageTabsTrigger value="ui-restrictions">{t("UI restrictions")}</PageTabsTrigger>
            <PageTabsTrigger value="admin">{t("Admin")}</PageTabsTrigger>
            <PageTabsTrigger value="portal-schema">{t("Portal")}</PageTabsTrigger>
          </PageTabsList>
        </DialogHeader>
        <RoleSettingsTabContent editor={editor} />
        <UIRestrictionsTabContent editor={editor} />
        <RoleAdminTabContent editor={editor} />
        <PortalSchemaTabContent editor={editor} />
      </PageTabs>
      <DialogFooter className="bg-gray-100 rounded-b-md flex justify-end items-center gap-2">
        <DialogClose>
          <Button variant="outline">{t("Cancel")}</Button>
        </DialogClose>
        <Button
          disabled={!editor.isDirty || !editor.isValid || editor.isSaving}
          onClick={() => editor.save(onClose)}
          data-trackingid="edit-role-dialog-save"
        >
          {t("Save Changes")}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
